import React, { useState } from "react";
import { CheckIcon, CopyIcon } from "lucide-react"; // 或者使用你现有的图标库
import { IconButton } from "@/components/icon-button";
import toast from "react-hot-toast";

export const CopyCellText = ({ text }: { text?: string }) => {
  const [isCopied, setIsCopied] = useState(false);

  if (!text) {
    return <></>
  }

  const handleCopy = async () => {
    try {
      // 移除 Markdown 格式，获取纯文本
      const plainText = text
        .replace(/^#+\s+/gm, "") // 移除标题
        .replace(/\*\*(.*?)\*\*/g, "$1") // 移除加粗
        .replace(/\*(.*?)\*/g, "$1") // 移除斜体
        .replace(/!?\[(.*?)\]\(.*?\)/g, "$1") // 移除链接和图片
        .replace(/`{3}.*?\n[\s\S]*?`{3}/g, "") // 移除代码块
        .replace(/`(.*?)`/g, "$1") // 移除行内代码
        .replace(/~~(.*?)~~/g, "$1") // 移除删除线
        .replace(/^\s*[-*+]\s+/gm, "") // 移除列表标记
        .replace(/^\s*\d+\.\s+/gm, ""); // 移除有序列表标记

      await navigator.clipboard.writeText(plainText);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1000);
      toast.success('复制成功');
    } catch (err) {
      toast.success('复制失败');
    }
  };

  return (
    <IconButton
      onClick={handleCopy}
      aria-label="复制内容"
      label="复制内容"
    >
      {isCopied ? (
        <CheckIcon className="h-4 w-4 text-constructive" />
      ) : (
        <CopyIcon className="h-4 w-4" />
      )}
    </IconButton>
  );
};
